import { number, route, string } from "react-router-typesafe-routes/dom";

export const ROUTES = {
  Root: route(""),
  ContactUs: route("contact-us"),
  ExternalSignIn: route("signin"),
  ExternalRegister: route("register"),
  InternalSignIn: route("internal"),
  SignOut: route("signout"),
  MoreInfo: route(
    "more-info",
    {},
    {
      Artist: route("artist"),
      AMP: route("art-market-professional"),
      AC: route("art-centre"),
    },
  ),
  ForgotPassword: route("forgot-password"),
  ResetPassword: route("reset-password/:user?", {
    params: {
      user: string(),
    },
  }),
  NoticeOfResale: route("notice-of-resale"),
  HowToUseTemplate: route("how-to-use-template"),
  ResaleSubmission: route(
    "resale-submission",
    { searchParams: { index_id: number() } },
    {
      SelectParticipant: route("select-participant"),
      ArtistDetails: route("artist-details"),
      ArtworkDetails: route("artwork-details", { searchParams: { artistBatchDiscriminator: string() } }),
      ResaleDetails: route("resale-details"),
      ReviewResale: route("review-resale"),
    },
  ),
  RegisterSubmission: route(
    "register-submission",
    { searchParams: { index_id: number() } },
    {
      UserRole: route("user-role"),
      ParticipantType: route("participant-type"),
      UserDetails: route("user-details"),
      RegisterSuccess: route("register-success"),
    },
  ),
  ResaleCsvSubmission: route(
    "resale-csv-upload",
    {},
    {
      SelectParticipant: route("select-participant"),
      UploadCsv: route("upload-csv"),
      UploadReview: route("upload-review"),
      ReuploadReview: route("reupload-review"),
    },
  ),
  SubmitAllResales: route("submit-all-resales"),
  Dashboard: route(
    "dashboard",
    {},
    {
      Accounts: route("accounts"),
      NewAccounts: route(
        "new-accounts",
        { searchParams: { index_id: number() } },
        {
          UserRole: route("user-role"),
          ParticipantType: route("participant-type"),
          UserDetails: route("user-details"),
          RegisterSuccess: route("register-success"),
        },
      ),

      CurrentRoyalties: route("current-royalties"),
      PastRoyalties: route("past-royalties"),
      ReportNewResale: route("report-new-resale"),
      PendingPayments: route("pending-payments"),
      PastResales: route("past-resales"),
      HelpCentre: route("help"),
      Settings: route("settings"),
      UnderReview: route("under-review"),
      ReportsToReview: route("reports-to-review"),
      HoldPeriod: route("hold-period"),
      PastReports: route("past-reports"),
      PastResaleReports: route("past-resale-reports"),
      UpcomingRoyalties: route("upcoming-royalties"),
      PastPayments: route("past-payments"),
      RecentReports: route("recent-reports"),
      Profile: route(
        "profile/:participantId?",
        {
          params: {
            participantId: number(),
          },
        },
        {
          AccountDetails: route("account-details"),
          AccountRelationships: route("account-relationships"),
          CurrentRoyalties: route("current-royalties"),
          PastRoyalties: route("past-royalties"),
          UnderReview: route("under-review"),
          PendingPayments: route("pending-payments"),
          PastResaleReports: route("past-resale-reports"),
        },
      ),
      ProfileWildcard: route("profile/:participantId?/*", {
        params: {
          participantId: number(),
        },
      }),
    },
  ),
  Profile: route(
    "profile/:participantId?",
    {
      params: {
        participantId: number(),
      },
    },
    {
      AccountDetails: route("account-details"),
      AccountRelationships: route("account-relationships"),
      CurrentRoyalties: route("current-royalties"),
      PastRoyalties: route("past-royalties"),
      UnderReview: route("under-review"),
      PendingPayments: route("pending-payments"),
      PastResaleReports: route("past-resale-reports"),
    },
  ),
};
